import React from 'react';
import {useMemo} from "react";
import moment from "moment";
import ChatDrawerAvatar from "@iso/components/ChatDrawer/ChatDrawerAvatar";

const MAX_DAY_SHOW_DATE_NOW = 5;

const ChatDrawerMessage = ({ message, createdAt , isOwner, user }) => {
  const msgCreatedAt = useMemo(() => {
    if (!createdAt) return null;

    const dateCreated = moment(createdAt);
    const diffWithTodayDays = moment().diff(dateCreated, 'days');

    return diffWithTodayDays <= MAX_DAY_SHOW_DATE_NOW
      ? dateCreated.calendar()
      : dateCreated.format('MMMM Do YYYY, h:mm:ss a');
  }, [createdAt]);

  return (
    <>
      {isOwner ? (
        <div className='flex justify-end mb-4'>
          <div className='flex flex-col items-end'>
            <div className='mr-2 flex justify-end'>
              <span className='text-xs'>{msgCreatedAt}</span>
            </div>
            <div className='mr-2 py-3 px-4 bg-message-owner rounded-bl-3xl rounded-tl-3xl rounded-tr-xl'>
              <div className='mr-2 chat-content'>{message}</div>
            </div>
          </div>
        </div>
      ) : (
        <div className='flex justify-start mb-4 items-end'>
          <div className='min-w-8'>
            <ChatDrawerAvatar
              fullName={user.fullName}
              avatarURL={user.avatar}
            />
          </div>
          <div className='flex flex-col'>
            <div className='ml-2'>
              <span className='text-xs font-bold mr-1'>{`${user.fullName}`}</span>
              <span className='text-xs'>{msgCreatedAt}</span>
            </div>
            <div className='ml-2 py-3 px-4 bg-message rounded-br-3xl rounded-tr-3xl rounded-tl-xl'>
              <div className='chat-content'>{message}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ChatDrawerMessage;